import { render, staticRenderFns } from "./otherProfitLog.vue?vue&type=template&id=5c9871cd&scoped=true&"
import script from "./otherProfitLog.vue?vue&type=script&lang=js&"
export * from "./otherProfitLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9871cd",
  null
  
)

export default component.exports